import React, { useContext, useEffect, useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid'
import { Stack } from '@mui/material'
import { Row, sharedColDefs } from './supplierPageConstants'
import { FilterContext } from '../../../context/FilterContext'
import { SupplierPageDataGrid } from './SupplierPageDataGrid'
import { useInvoiceGroupRows } from './useInvoiceGroupRows'
import { Body1 } from '../../../components/Typography'
import { ErrorSnackBarContext } from '../../../context/ErrorSnackBarContex'
import { captureException } from '../../../utils/Sentry'

function NoResultRow() {
  return (
    <Stack height='100%' alignItems='center' justifyContent='center'>
      <Body1>Inget matchar sökvillkoren</Body1>
    </Stack>
  )
}

export function InvoiceGroupGrid(params: {
  selectedGroup: string
  selectedYear?: number
}): React.JSX.Element {
  const { selectedGroup, selectedYear } = params

  const coldefs = useMemo<GridColDef<Row>[]>(
    () => [
      {
        field: 'name',
        headerName: selectedGroup,
        flex: 1,
      },
      ...sharedColDefs,
    ],
    [selectedGroup],
  )

  const { orgUnit } = useContext(FilterContext)

  const { setError } = useContext(ErrorSnackBarContext)

  const { rows, loading, error } = useInvoiceGroupRows({
    selectedGroup,
    selectedYear,
    selectedOrgUnit: orgUnit?.id,
  })

  useEffect(() => {
    if (error) {
      setError()
      captureException(error)
    }
  }, [error, setError])

  return (
    <SupplierPageDataGrid
      gridKey={selectedGroup}
      coldefs={coldefs}
      rows={rows}
      loading={loading}
      NoSearchResult={NoResultRow}
    />
  )
}
